import { BaseContractAddresses } from '@repo/types-client';

const _registry: Record<string, BaseContractAddresses> = {
  mainnet: {
    avatar: '0x7D27453Aab0BFF89CB91B9d307db557e0A2D15DD',
    avatarMetadata: '0xaf9c2d961D325393699A9Ff6584a0B9Fc770e050',
    coreMinter: '0xa48d6A1765d18D03d33Ee99091f81408b2a20b6F',
    doodlesAccessManager: '0x0fF9A807f1c8D220344aeb4AcB2fBf0812508184',
    erc2771Forwarder: '0x55ee059d23c55B5A6953823286A718Feb82Cf70B',
    executionAuthority: '0x0000000000000000000000000000000000000000',
    pack: '0x4B3E2eD66631FE2dE488CB0c23eF3A91A41601f7',
    pass: '0x76FEa18dcA768c27Afc3a32122c6b808C0aD9b06',
    redeemable: '0xf811631adBF9990a8d2c2d822C5C534cDD76aAe1',
    splitterManager: '0x36FF291c9aC8Fec16CF5Af9d4aF7A92c47511C70',
    templateRegistry: '0x7590dC5C31e216026275CbAdc731FAe4e1C75640',
    wearable: '0xb5F58FE2FdD79B279bF2b201F91Ba784b79c8744',
  },
  sepolia: {
    avatar: '0x4727ad6498563915587FEEbDaB4F1eE705EdFdA3',
    avatarMetadata: '0xD835249D9923A2045B2844AA6532698d7FfdfDE8',
    coreMinter: '0x8248f49fF634e1Bd689fe0c83358B64396Ec79d9',
    doodlesAccessManager: '0x195C7e3669Add205985660DB6E67D5Ce2CB2a906',
    erc2771Forwarder: '0x9E957f7b2A00fe8c9AD885b1D1D937a8E005baf5',
    executionAuthority: '0x8236E667646F575BadbbdC6cFA37DFe1FAd16574',
    pack: '0xF25bAFEdD78cFB307B2d8e363c926fC86cFD1f42',
    pass: '0x460a19E050Ff7D59E7708D665fAa7ADAF2429891',
    redeemable: '0x852A4Ee627da38F2a7294d7Afac0cd15874D6568',
    splitterManager: '0x2Aa02719b33B7BCe9b50534f322419031257739E',
    templateRegistry: '0x5dC9961365C1af02F128C2329ddAa1674137A7FF',
    wearable: '0x039d175F26BA22E75CD06a2Be30dEd0B46cb4f10',
  },
};

let _selectedNetwork: BaseContractAddresses;

switch (process.env.NEXT_PUBLIC_APP_ENV) {
  case 'production':
    _selectedNetwork = _registry.mainnet ?? ({} as BaseContractAddresses);
    break;
  default:
    _selectedNetwork = _registry.sepolia ?? ({} as BaseContractAddresses);
    break;
}

export const baseContractAddresses =
  _selectedNetwork as Readonly<BaseContractAddresses>;
